import React, { useEffect, useMemo, useState } from 'react';
import styles from '../styles/aboutcomponent.module.css';
import GalleryCard from '../../common/GalleryCard';

const AdvisoryCommittee = () => {
  const [committee, setCommittee] = useState([]);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    fetch(`${baseUrl}/documents?type=about&subType=committee`)
      .then((res) => res.json())
      .then((data) => setCommittee(data || []))
      .catch((err) => console.error('Error fetching committee:', err));
  }, []);

  const memoizedCommittee = useMemo(() => committee, [committee]);

  return (
    <div className={styles.about_component}>
      <h4>ADVISORY COMMITTEE OF SNEHWAN</h4>
      <div className={styles.committe}>
        {memoizedCommittee.map((item, index) => (
          <div key={index} className={styles.counting_item}>
            <GalleryCard photo={item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvisoryCommittee;